import script from "./HeaderCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderCarousel.vue?vue&type=script&setup=true&lang=js"

import "./HeaderCarousel.vue?vue&type=style&index=0&id=6257688c&lang=css"

const __exports__ = script;

export default __exports__